const operators = ["+","-","*","/"];

export default operators;

